import React from "react";
import { Link } from "react-router-dom";

const HeroArea = () => {
  return (
    <div
      className="breadcumb-wrapper"
      style={{
        backgroundImage: "url(/img/1.jpg)",
        // marginTop: "165px",
      }}
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Properties</h1>
          <div className="breadcumb-menu-wrap">
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Property Details</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroArea;
